import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
// import { getUserDetails } from "../utilities/get-user-details-from-cokies";
import Button from "../Button";
import Pagination from "../Pagination";
import { communication } from "../../services/communication";
import { CustomSearchBox } from "../../utilities/CustomSearchBox";

const pageLimit = process.env.REACT_APP_LIMIT || 20;

const UserManagement = () => {
  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPageUpdated, setIsPageUpdated] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [timeoutId, setTimeoutId] = useState(null);

  async function getUserList(page = 1, search = "") {
    try {
      setLoader(true);
      const response = await communication.getApplicationList(page, search);
      if (response?.data?.status === true) {
        setUserList(response?.data?.data?.allForms);
        setPageCount(response?.data?.data.totalPages);
      } else if (response?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: response.data.message, icon: "warning" });
        navigate("/login");
      } else {
        setUserList([]);
        setPageCount(0);
      }
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error.message,
        icon: "warning",
      });
    } finally {
      setLoader(false);
    }
  }

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    clearTimeout(timeoutId);

    const _timeoutId = setTimeout(() => {
      getUserList(currentPage, e.target.value);
    }, 1000);
    setTimeoutId(_timeoutId);
  };

  const deleteUser = async (id, event) => {
    event.stopPropagation();
    const confirmation = await Swal.fire({
      text: "Do you really want to delete this User?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (confirmation.isConfirmed) {
      try {
        setLoader(true);
        const response = await communication.deleteUser(id);

        if (response?.data?.status === "SUCCESS") {
          Swal.fire({ text: response.data.message, icon: "success" });
          await getUserList(currentPage, searchString);
        } else {
          Swal.fire({
            text: response.data.message || "Deletion failed",
            icon: "error",
          });
        }
      } catch (error) {
        Swal.fire({
          text: error?.response?.data?.message || error.message,
          icon: "warning",
        });
      } finally {
        setLoader(false);
      }
    }
  };

  useEffect(() => {
    getUserList(currentPage, searchString);
  }, [isPageUpdated]);

  return (
    <>
      <div className="actionbar_main_wrraper">

        <div className="other_action">
          {/* <Button
            onClick={() => navigate("/main-panel/user-management/add-user")}
            className="btn btn-primary button_main"
            text="Create User"
          /> */}
          <CustomSearchBox
            searchString={searchString}
            setSearchString={setSearchString}
            apiCall={getUserList}
            setCurrentPage={setCurrentPage}
          />
          <Pagination
            isPageUpdated={isPageUpdated}
            setIsPageUpdated={setIsPageUpdated}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageCount={pageCount}
          />
        </div>
      </div>

      <div className="table_wrapper">
        <div className="table_main">
          <div className="table_section user-management_table">
            <div className="table_header">
              <div className="col_7p"><h5>Sr. No.</h5></div>
              <div className="col_10p"><h5>Name</h5></div>
              <div className="col_10p"><h5>Mobile No</h5></div>
              <div className="col_25p"><h5>Email Id</h5></div>
              <div className="col_7p"><h5>Status</h5></div>
              <div className="col_7p"><h5>Date</h5></div>
              <div className="col_10p"><h5>Action</h5></div>
            </div>

            {userList.length > 0 ? (
              userList.map((item, index) => (
                <div className="table_data" key={item._id}>
                  {/* <div className="col_7p"><h6>{index + 1}</h6></div> */}
                  <div className="col_7p"><h6>{(currentPage - 1) * pageLimit + (index + 1)}</h6></div>

                  <div
                    className="col_10p custom_link"
                    onClick={() =>
                      navigate(`/main-panel/user-management/update-user?id=${item._id}`)
                    }
                  >
                    <h6>{item?.personalDetails?.name}</h6>
                  </div>
                  <div className="col_10p"><h6>{item?.personalDetails?.mobileNumber}</h6></div>
                  <div className="col_25p"><h6>{item?.personalDetails?.emailId}</h6></div>
                  <div className="col_7p"><h6>{item?.formStatus}</h6></div>
                  <div className="col_7p"><h6>{new Date(item?.createdAt).toLocaleDateString()}</h6></div>
                  <div className="col_10p">
                    <h6 className="action_wrraper">
                      <FontAwesomeIcon
                        icon={faEye}
                        className="cursor_pointer"
                        title="View User"
                        onClick={() =>
                          navigate(`/main-panel/user-management/update-user?id=${item._id}`)
                        }
                      />
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="cursor_pointer"
                        title="Delete User"
                        onClick={(event) => deleteUser(item._id, event)}
                      />
                    </h6>
                  </div>
                </div>
              ))
            ) : (
              <div className="data_not_available"><h6>No Data Available</h6></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserManagement;
